import {
  mapperModuleTerminalConnectivitySpecs,
  mapperModuleTerminalHardwareSpecs,
  mapperModuleTerminalIntegrationSpecs,
  mapperModuleTerminalPaymentExperienceSpecs
} from '../../modules/mappers'

/**
 * Block terminal specs mapper
 * @param {Object} data - cms response data
 * @return {Object} the normalized data
 */
export default (data: any) => {
  if (!data) {
    return null
  }

  return {
    hardwareTitle: data.hardwareTitle || '',
    hardware: data.hardwareCollection?.items?.map(mapperModuleTerminalHardwareSpecs) || [],
    connectivityTitle: data.connectivityTitle || '',
    connectivity: data.connectivityCollection?.items?.map(mapperModuleTerminalConnectivitySpecs) || [],
    paymentExperienceTitle: data.paymentExperienceTitle || '',
    paymentExperience: data.paymentExperienceCollection?.items?.map(mapperModuleTerminalPaymentExperienceSpecs) || [],
    integrationTitle: data.integrationTitle || '',
    integration: data.integrationCollection?.items?.map(mapperModuleTerminalIntegrationSpecs) || []
  }
}
